import { render, staticRenderFns } from "./Expand.vue?vue&type=template&id=15d20c0e&scoped=true"
import script from "./Expand.vue?vue&type=script&lang=js"
export * from "./Expand.vue?vue&type=script&lang=js"
import style0 from "./Expand.vue?vue&type=style&index=0&id=15d20c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d20c0e",
  null
  
)

export default component.exports